import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;
}
interface CategoryTypeProps {
  name?: string,
  initialValue?: Option;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean,
}

const CategoryType = ({
  name = '',
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
}: CategoryTypeProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const result = dataList?.map((item) => ({ label: item?.label, value: String(item?.value) })) || [] as Option[];
    setOptions((_prev: any) => result);
    if (initialValue) {
      const val = result?.find((e: any) => e.value === initialValue?.value);
      setOnChangeOption(val);
    } else {
      setOnChangeOption(result[0]);
    }
  }, [JSON.stringify(dataList)]);

  return (
    <React.Fragment>
      <Select
        options={options}
        value={initialValue}
        name={name}
        isDisabled={disabled}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ''}</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        className="dropdown-status-rounded select-category-type"
        classNamePrefix="name-prefix"
      />
    </React.Fragment>
  );
};

export default CategoryType;
